var map = {
	"./ferry.json": [
		335,
		48
	],
	"./fishballs.json": [
		336,
		49
	],
	"./hiker_boys.json": [
		337,
		50
	],
	"./hiker_girls.json": [
		338,
		51
	],
	"./lion.json": [
		339,
		52
	],
	"./milk_tea.json": [
		340,
		53
	],
	"./neon.json": [
		341,
		54
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 96;
module.exports = webpackAsyncContext;